/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "dollar",

    getDefaultProps: function getDefaultProps() {
        return {
            "dollar": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "31.5",
            "height": "69.2"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31.5 69.2", className: "dollar", width: this.props.width, height: this.props.height, style: this.props.dollar },
            _react2["default"].createElement("path", { fill: "#999", d: "M12.9 69.2v-8.5C8 60.6 2.9 59.1 0 57l2-5.6c3 2 7.4 3.6 12.1 3.6 6 0 10-3.5 10-8.3 0-4.6-3.3-7.5-9.5-10C6.1 33.3.8 29.4.8 22.1c0-7 5-12.3 12.7-13.6V0h5.2v8.2c5.1.2 8.5 1.5 11 2.9l-2.1 5.6c-1.8-1-5.2-2.9-10.6-2.9-6.5 0-8.9 3.9-8.9 7.2 0 4.4 3.1 6.6 10.4 9.6 8.7 3.5 13.1 7.9 13.1 15.4 0 6.7-4.6 12.9-13.3 14.3v8.8h-5.4z" })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/dollar.js